<template>
  <div>
    <v-stepper-step :complete="currentStep > 3" step="4">
      <h3>Step 4</h3>
      <div v-show="currentStep == 1" class="text-caption">
        <p>
          <span class="red--text"><strong>* </strong></span>= Mandatory field
        </p>
      </div>
    </v-stepper-step>
    <v-stepper-content step="4">

      <v-row>
        <v-col cols="12">
          <v-container class="summaryBox">
            <v-row class="summaryRow" no-gutters>
              <v-col cols="12" sm="4" class="font-weight-bold">
                {{this.deliveryTypeDescription}}
              </v-col>
              <v-col v-if="this.deliveryType===deliveryTypes.ADDRESS" cols="12" sm="8">
                <span>{{ currentRequest.deliveryAddress.houseNameNumber }}</span>
                <span><br />{{ currentRequest.deliveryAddress.streetName }}</span>
                <span><br />{{ this.localityName }}</span>
                <span><br />{{ currentRequest.deliveryAddress.postCode }}</span>
              </v-col>
              <v-col v-if="this.deliveryType===deliveryTypes.LOCKER" cols="12" sm="8">
                <span>{{ this.parcelLockerName }}</span>
                <span><br />{{ currentRequest.deliveryAddress.easipikCustomerCode }}</span>
              </v-col>
              <v-col v-if="this.deliveryType===deliveryTypes.POSTOFFICE" cols="12" sm="8">
                <span>{{ this.postOfficeName }}</span>
              </v-col>
              <v-col v-if="this.deliveryType===deliveryTypes.KEEPITEMS" cols="12" sm="8">
                <v-row v-for="item in trackingNumbersEligibleForRedelivery" :key="item.TrackingNumber">
                <v-col cols="12" sm="6">{{ item.trackingNumber }}</v-col>
                <v-col cols="12" sm="6">{{ item.postOfficeName }}</v-col>
                </v-row>
              </v-col>

            </v-row>
          </v-container>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <v-container v-for="item in this.trackingNumbers" :key="item.trackingNumber" class="summaryBox">
            <v-row class="summaryRow" no-gutters>
              <v-col cols="12" sm="4">Tracking Number</v-col>
              <v-col cols="12" sm="4">{{ item.trackingNumber ? item.trackingNumber : 'No tracking number provided' }}</v-col>
              <v-col cols="12" sm="4"><span
                  :class="[isTrackingNumberMustExist && !item.isFound ? 'notFound' : '']">{{isTrackingNumberMustExist &&
                  !item.isFound && parcelType === parcelTypes.Tracked ? 'Barcode not found in system. Please edit or remove it to proceed.' : ''}}</span></v-col>
            </v-row>

            <v-expansion-panels v-if="item.isFound || (item.parcelType === parcelTypes.Untracked && item.redeliveryType === deliveryTypes.KEEPITEMS)"
              :disabled="!(item.isFound || (item.parcelType === parcelTypes.Untracked && item.redeliveryType === deliveryTypes.KEEPITEMS)) || item.isPaid" focusable>
              <v-expansion-panel>
                <v-expansion-panel-header class="chargePanelHeader" v-slot="{ open }">
                  <v-row class="chargeSummaryRow" no-gutters>
                    <v-col cols="12" sm="4"><span class="font-weight-bold">{{ !item.isFound || item.isPaid ?
                    (deliveryType===deliveryTypes.KEEPITEMS ? 'Keep at Post Office Charge' :'Redelivery') : 'Charge'}}</span> <span v-if="!open && item.isFound && !item.isPaid">(expand for
                        details)</span></v-col>
                    <v-col cols="12" sm="8" class="text-right font-weight-bold"
                      :class="[!item.isFound || item.isPaid ? 'chargePanelHeaderAmountPaid' : 'chargePanelHeaderAmount']">
                      {{
                      item.redeliveryIsFree && item.isPaid ? 'Free' :
                      '€'+item.totalDueIncludingRedelivery.toFixed(2) }}</v-col>
                  </v-row>
                </v-expansion-panel-header>
                <v-expansion-panel-content class="chargePanelContent">

                  <v-row v-if="item.redeliveryCharge">
                    <v-col cols="12" sm="4" class="chargeDetailLabel">{{ deliveryType===deliveryTypes.KEEPITEMS ? 'Keep at Post Office Charge (' + item.keepAtPOWeeks+" week(s), €"+item.keepAtPOChargePerWeek+"/week)" :'Redelivery' }}</v-col>
                    <v-col cols="12" sm="8" class="text-right chargeDetailValue">
                      €{{item.redeliveryCharge.toFixed(2)}}</v-col>
                  </v-row>
                  <v-row v-for="(charge,index) in item.trackedItemCharges.filter(c => !c.paidPriorToRedeliveryRequest)" :key="index">
                    <v-col cols="12" sm="4" class="chargeDetailLabel">{{charge.chargeType.description}}
                    </v-col>
                    <v-col cols="12" sm="8" class="text-right chargeDetailValue">€{{charge.totalWithTax.toFixed(2)}}
                    </v-col>
                  </v-row>

                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>


          </v-container>
        </v-col>
      </v-row>
      <v-row v-if="!isTrackingNumberMustExist || isFound">
        <v-col cols="12">
          <v-container class="summaryBox">

            <v-row class="summaryRow" no-gutters>
              <v-col cols="12" sm="4" class="font-weight-bold">Total</v-col>
              <v-col cols="12" sm="8" class="text-right font-weight-bold summaryRowValue"> {{isFree?'Free':
              '€'+ (charges.totalDueIncludingRedelivery ?
              charges.totalDueIncludingRedelivery.toFixed(2) : null) }}</v-col>
            </v-row>
          </v-container>
        </v-col>
      </v-row>

      <v-btn color="primary" @click="goNext()" :disabled="isTrackingNumberMustExist && !isFound">
        {{isFree ? 'Complete' : 'Pay'}}
      </v-btn>
      <v-btn text @click="currentStep = 3"> Back </v-btn>
    </v-stepper-content>
  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
import parcelTypes from "../../constants/parcelTypes";
import deliveryTypes from "../../constants/deliveryTypes";

const { mapGetters: mapMissedDeliveryGetters } = createNamespacedHelpers(
  "missedDelivery"
);

export default {
  name: "Step04",
  data() {
    return {
      parcelTypes: parcelTypes,
      deliveryTypes: deliveryTypes
    };
  },
  computed: {
    ...mapMissedDeliveryGetters(["charges", "currentRequest", "localities", "parcelLockers", "postOffices", "settings", "trackingNumbersEligibleForRedelivery"]),
    currentStep: {
      set(currentStep) {
        this.$store.dispatch("missedDelivery/setCurrentStep", currentStep);
      },
      get() {
        return this.$store.getters["missedDelivery/currentStep"];
      },
    },
    parcelType: {
      get() {
        return this.currentRequest.notice.parcelType;
      }
    },
    trackingNumbers: {
      get() {
        return this.charges.trackedItems;
      }
    },
    localityName: {
      get() {
        const currentRequest = this.currentRequest;
        var locality = this.localities.find(function (l) {
          return l.id === currentRequest.deliveryAddress.localityId
        });
        if (locality) {
          return locality.name;
        }
        return null;
      }
    },
    parcelLockerName: {
      get() {
        const currentRequest = this.currentRequest;
        const pl = this.parcelLockers.find(function (pl) {
          return pl.id === currentRequest.deliveryAddress.parcelLockerId
        });
        if (pl) {
          return pl.name;
        }
        return null;
      }
    },
    postOfficeName: {
      get() {
        const currentRequest = this.currentRequest;
        var po = this.postOffices.find(function (po) {
          return po.id === currentRequest.deliveryAddress.postOfficeId
        });
        if (po) {
          return po.name;
        }
        return null;

      }
    },
    deliveryType: {
      get() {
        const currentRequest = this.currentRequest;
        const type = currentRequest.deliveryAddress.type;
        return type;
      }
    },
    deliveryTypeDescription: {
      get() {
        const currentRequest = this.currentRequest;
        const type = currentRequest.deliveryAddress.type;

        if (type === deliveryTypes.ADDRESS) {
          return "Delivery to address";
        } else if (type === deliveryTypes.LOCKER) {
          return "Delivery to locker";
        } else if (type === deliveryTypes.POSTOFFICE) {
          return "Delivery to post office";
        } else if (type === deliveryTypes.KEEPITEMS) {
          return "Keep items at post office";
        }
        return "";
      }
    },
    isTrackingNumberMustExist: {
      get() {
        const settings = this.settings;
        if (settings) {
          return settings.trackingNumberMustExist;
        }
        return false;
      }
    },
    isFound: {
      get() {
        const charges = this.charges;
        if (charges) {
          return charges.isFound;
        }
        return false;
      }
    },
    isFree: {
      get() {
        const charges = this.charges;
        if (charges) {
          return charges.isFree;
        }
        return false;
      }
    }
  },
  methods: {
    goNext() {

      //if there is nothing to pay, submit request
      //if there is something to pay, redirect to payment page (we will submit after payment is complete)

      if (this.isFree) {
        this.$store.dispatch("missedDelivery/submit");
      }
      else {
        this.$store.dispatch("missedDelivery/pay");
      }
    }
  },

};
</script>
<style scoped>
.summaryBox {
  margin-left: 0px;
  margin-right: 0px;
}

.summaryRow {
  background-color: lightgray;
  margin-top: 1px;
  margin-bottom: 1px;
  padding-left: 10px;
}

.chargeSummaryRow {
  margin-top: 1px;
  margin-bottom: 1px;
  padding-left: 10px;
  color: rgba(0, 0, 0, 1)
}

.chargePanelHeader {
  padding-left: 0px;
}

.chargePanelContent {
  margin-left: -15px
}

.chargePanelHeaderAmount {
  padding-left: 15px;
}

.chargePanelHeaderAmountPaid {
  padding-right: 25px;
}

.chargeDetailLabel {
  padding-bottom: 0px;
}

.chargeDetailValue {
  padding-bottom: 0px;
  padding-right: 35px
}

.summaryRowValue {
  padding-right: 50px
}

.notFound {
  color: red
}

</style>